import {
  ChangeDetectionStrategy,
  ChangeDetectorRef, Component,
  OnInit, ViewChild
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';

import { State } from '../../../../vista-usuario/vista-usuario.state';

import {
  FileService, NotificationService, ROUTE_ANIMATIONS_ELEMENTS
} from '../../../../../core/core.module';

import {
  Actividad,
  CurrentEmpresa, FormActionType,
  Pais, PaisDocumento, RolActividad, TipoActividad, TipoRol, TiposDocumento
} from '@rpe/registro-personas-empresas-lib';
import { selectAllPaises } from '../../../../ubicaciones/entity-paises/entity-paises.selectors';
import { selectAllRolesActividad } from '../../../entity-roles-actividad/entity-roles-actividad.selectors';
import { selectAllTiposDocumento } from '../../../../persona/entity-tipos-documento/entity-tipos-documento.selectors';
import { selectAllTiposRol } from '../../../entity-tipos-rol/entity-tipos-rol.selectors';

import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { selectAllEntidadesProductiva } from '../../../../empresas/entity-entidad-productiva/entity-entidades-productiva.selectors';
import { selectAllCurrentEmpresa } from '../../../../empresas/entity-mis-empresas/entity-current-empresa.selectors';
import { selectAllRol } from '../../../entity-roles/entity-roles.selectors';
import { selectAllTiposActividad } from '../../../../actividades/entity-tipos-actividad/entity-tipos-actividad.selectors';

import { forkJoin } from 'rxjs';
import { selectAllActividades } from '../../../../actividades/entity-actividades/entity-actividades.selectors';

import {
  entityIntegranteAddRequest,
  entityIntegranteChangeRequest
} from '../../entity-integrante.actions';
import { EntidadesProductiva } from '../../../../empresas/entity-entidad-productiva/entity-entidades-productiva.model';
import { IntegranteFormComponent } from '../../../integrante/integrante-form/integrante-form.component';
import { Integrante, IntegranteFormInput } from '../../../integrante/integrante.model';
import { Rol, ActividadConNombre } from '../../../entity-roles/roles.model';
import { selectAllPersonas } from '../../../../persona/entity-personas/entity-personas.selectors';
import { Persona } from '../../../../persona/entity-personas/entity-personas.model';
import { selectAllPaisesDocumento } from '../../../../ubicaciones/entity-paises-documento/paises-documento.selectors';

@Component({
  selector: 'rpe-entity-integrante-form-container',
  templateUrl: './entity-integrante-form-container.component.html',
  styleUrls: ['./entity-integrante-form-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EntityIntegranteFormContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  @ViewChild(IntegranteFormComponent)
  integranteForm: IntegranteFormComponent;

  paises$: Observable<Pais[]> | undefined;

  formValid: boolean = false;
  formValue: Integrante;
  idRolNavPar: number = null;
  modoAccion: string = null;

  //mover el form input para donde corresponda
  formInput: IntegranteFormInput = {
    action: FormActionType.Add,
    documento_persona: null,
    tipos_rol: [],
    paises: [],
    tipos_documento: [],
    actividadesConNombre: [],
    integrante: null,
    entidad_productiva_id: null,
    paises_documento: null
  };

  rolesActividad: RolActividad[] = [];
  tiposActividad: TipoActividad[] = [];
  actividadesCurrentEmpresa: Actividad[] = [];

  constructor(
    public store: Store<State>,
    private ref: ChangeDetectorRef,
    private readonly notificationService: NotificationService,
    private router: Router,
    private fileService: FileService
  ) {
    this.idRolNavPar =
      this.router?.getCurrentNavigation()?.extras?.state?.idRol;
    this.modoAccion = this.router?.getCurrentNavigation()?.extras?.state?.modo;

    let action: FormActionType;
    //se debe recibir por parametro el tipo que uno quiere ejecutar ya sea
    //edicion vista en caso de no recibir parametros desde la url se supone que es un agregar
    switch (this.modoAccion) {
      case 'editar':
        action = FormActionType.Update;
        break;
      case 'ver':
        action = FormActionType.View;
        break;
      default:
        action = FormActionType.Add;
        break;
    }

    this.formInput = {
      ...this.formInput,
      action: action
    };
  }

  ngOnInit(): void {
    //se usa un doble combine ya que son mas de 6 elementos (combine solo permite 6 elementos)
    let resultado = combineLatest([
      combineLatest([
        this.store.pipe(select(selectAllCurrentEmpresa)),
        this.store.pipe(select(selectAllTiposRol)),
        this.store.pipe(select(selectAllRolesActividad)),
        this.store.pipe(select(selectAllTiposActividad)),
        this.store.pipe(select(selectAllEntidadesProductiva))
      ]),
      combineLatest([
        this.store.pipe(select(selectAllPaises)),
        this.store.pipe(select(selectAllTiposDocumento)),
        this.store.pipe(select(selectAllPaisesDocumento)),
        this.store.pipe(select(selectAllRol)),
        this.store.pipe(select(selectAllPersonas)),
        this.store.pipe(select(selectAllActividades))
      ])
    ]).pipe(
      map(([r1, r2]) => {
        return [...r1, ...r2] as [
          CurrentEmpresa[],
          TipoRol[],
          RolActividad[],
          TipoActividad[],
          EntidadesProductiva[],
          Pais[],
          TiposDocumento[],
          PaisDocumento[],
          Rol[],
          Persona[],
          Actividad[]
        ];
      })
    );
    resultado.subscribe(
      ([
        currentEmpresa,
        tipos_rol,
        roles_actividad,
        tipos_actividad,
        entidades_productiva,
        paises,
        tipos_documento,
        paises_documento,
        roles,
        personas,
        actividades
      ]) => {
        this.rolesActividad = roles_actividad;
        this.tiposActividad = tipos_actividad;

        //se verifican que roles estaran disponibles dependiendo de las actividades de la empresa
        let rolesFiltrados = null;

        if (currentEmpresa.length > 0) {
          //la entidad productiva es unica por lo cual tomamos la primera
          let currEmp = entidades_productiva.find(
            (cE) => cE.id == currentEmpresa[0].id
          );
          let activCurrEmpresa = currEmp.actividades;
          this.actividadesCurrentEmpresa = activCurrEmpresa;

          //si la entidad productiva tiene actividades de laborista entonces muestro tiporol laboratorio
          //si la empresa tiene actividades de acreditacion entonces muestro tiporol de tecnico responsable

          let hayActLab = activCurrEmpresa.find(
            (l) => l.tipo_actividad_id == 7
          );
          let hayActCer = activCurrEmpresa.find(
            (l) => l.tipo_actividad_id == 10
          );
          rolesFiltrados = tipos_rol.filter((rol) => {
            return (
              rol.id == 1 ||
              rol.id == 3 ||
              rol.id == 4 ||
              rol.id == 5 ||
              (rol.id == 6 && hayActCer) ||
              rol.id == 7 ||
              (rol.id == 8 && hayActLab) ||
              rol.id == 11
            );
          });
        }


        let integrante: Integrante = null;
        let actividadesOn: number[] = [];
        let auxActividadesConNombre: ActividadConNombre[] = [];
        if (this.idRolNavPar) {

          let rolEditar = roles.find((r) => r.id == this.idRolNavPar);
          let persona = personas.find((p) => p.id == rolEditar.persona_id);
          let documentoPersona = persona.documentos_persona[0];

          //encontrar los rolesActividad para el rol
          let rolesAct = roles_actividad.filter(
            (ra) => ra.rol_id == rolEditar.id
          );
          actividadesOn = rolesAct.map(
            (ra) => actividades.find((a) => a.id == ra.actividad_id).id
          );
          integrante = {
            laboratorios_id: [],
            nombre_completo: persona.nombre_completo,
            documento_persona: documentoPersona,
            cv: null,
            rol: rolEditar,
            actividades_id: actividadesOn
          };
          auxActividadesConNombre = this.obtenerActividadesPorTipoRol(
            rolEditar.tipo_rol_id
          );
        }


        this.formInput = {
          ...this.formInput,
          integrante: integrante,
          paises: paises,
          tipos_documento: tipos_documento,
          documento_persona: null,
          tipos_rol: rolesFiltrados,
          actividadesConNombre: auxActividadesConNombre,
          entidad_productiva_id: currentEmpresa[0]?.id,
          paises_documento: paises_documento
        };
        this.ref.detectChanges();
      }
    );
  }

  formStatusChanges(status: any) {
    this.formValid = status === 'VALID';
  }

  formValueChanges(nuevointegrante: any) {
    //las actividades dependen del rol, y los roles dependen de las actividades que tiene la entidadproductiva

    if (this.formValue?.rol?.tipo_rol_id != nuevointegrante.rol?.tipo_rol_id) {
      let actividadesConNombre = this.obtenerActividadesPorTipoRol(
        nuevointegrante.rol.tipo_rol_id
      );
      this.formInput = {
        ...this.formInput,
        actividadesConNombre: actividadesConNombre
      };
    }

    this.formValue = nuevointegrante;
  }

  //para cada tipoRol se hace el filtrado las actividades que tiene la empresa actual
  obtenerActividadesPorTipoRol(tipoRol: number) {

    if (tipoRol == null) {
      return [];
    }
    let actividadesConNombre: ActividadConNombre[] = [];
    let listaActividadesParaRol: Actividad[] = [];

    if (tipoRol == 8) {
      listaActividadesParaRol = this.actividadesCurrentEmpresa.filter(
        (a) => a.tipo_actividad_id == 7
      );
    } else if (tipoRol == 6) {
      listaActividadesParaRol = this.actividadesCurrentEmpresa.filter(
        (a) => a.tipo_actividad_id == 10
      );
    } else if (tipoRol == 5) {
      listaActividadesParaRol = this.actividadesCurrentEmpresa;
    } else {
      listaActividadesParaRol = [];
    }

    listaActividadesParaRol.forEach((act) => {
      let ta: TipoActividad = this.tiposActividad.find(({ id }) => {
        return id == act.tipo_actividad_id;
      });

      if (ta) {
        let aCN: ActividadConNombre = {
          actividad: act.id,
          nombreActividad: ta.nombre,
          tipoActividad: ta.id
        };
        actividadesConNombre.push(aCN);
      }
    });
    return actividadesConNombre;
  }

  //En caso que sera type view no se muestra en otro caso se muestra el boton de submit
  mostrarSubmit() {
    if (this.formInput.action == FormActionType.View) {
      return false;
    } else {
      return true;
    }
  }

  //TODO guardar y esperar para luego hacer el dispatch
  //este metodo debe mejorarse
  save() {
    let item = {
      ...this.formValue
    };

    if (this.formValue.rol.acreditacion_representacion && this.formValue.cv) {
      forkJoin([
        this.fileService.uploadFile(
          this.formValue.rol.acreditacion_representacion
        ),
        this.fileService.uploadFile(this.formValue.cv)
      ]).subscribe((results) => {
        this.formValue = {
          ...this.formValue,
          rol: {
            ...this.formValue.rol,
            acreditacion_representacion: results[0]
          },
          cv: results[1]
        };
        this.despachar();
      });
    } else if (this.formValue.rol.acreditacion_representacion) {
      this.fileService
        .uploadFile(this.formValue.rol.acreditacion_representacion)
        .subscribe((result) => {
          this.formValue = {
            ...this.formValue,
            rol: {
              ...this.formValue.rol,
              acreditacion_representacion: result
            }
          };
          this.despachar();
        });
    } else if (this.formValue.cv) {
      this.fileService.uploadFile(this.formValue.cv).subscribe((result) => {

        this.formValue = {
          ...this.formValue,
          cv: result
        };
        this.despachar();
      });
    } else {
      this.despachar();
    }
  }

  private despachar() {
    if (this.formInput.action === FormActionType.Add) {
      //this.notificationService.success('Integrante registrado con éxito');
      this.store.dispatch(
        entityIntegranteAddRequest({
          item: this.formValue
        })
      );
    } else if (this.formInput.action === FormActionType.Update) {
      //this.notificationService.success('Integrante modificado con éxito');
      this.store.dispatch(
        entityIntegranteChangeRequest({
          item: this.formValue
        })
      );
    }
  }

  onSubmit() {

    if (this.formValid) {
      this.save();
    } else {
      this.integranteForm.onShowErrors();
    }
  }
  onCancel() { }
}
